import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { EmissionsChartComponent } from 'src/app/shared/charts/emissions-chart/emissions-chart.component';
import { UIComponentsModule } from 'src/app/shared/ui-components/ui-components.module';
import { UserService } from 'src/app/core/services/user/user.service';
import { SnackbarService } from 'src/app/core/services/snackbar/snackbar.service';

@Component({
  selector: 'app-report',
  imports: [UIComponentsModule, EmissionsChartComponent],
  templateUrl: './report.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './report.component.scss',
})
export class ReportComponent implements OnInit {
  reportData: any = null;

  constructor(
    private userService: UserService,
    private snackbarService: SnackbarService
  ) {}

  ngOnInit(): void {
    this.loadEmissionsReport();
  }

  private loadEmissionsReport(): void {
    this.userService.getMyEmissionsReport().subscribe({
      next: (data) => {
        this.reportData = data;
      },
      error: (error) => {
        this.snackbarService.showErrorMessage(
          'Failed to load emissions report'
        );
        console.error('Error loading emissions report:', error);
      },
    });
  }
}
